import { Check } from "lucide-react";
import ContactFormDialog from "./ContactFormDialog";

const Pricing = () => {
  return (
    <section className="py-24 md:py-32 bg-muted/30">
      <div className="container px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Section header */}
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            Pricing
          </h2>
          <p className="text-lg text-muted-foreground mt-6 mb-12">
            Tailored engagement based on your stage and needs
          </p>

          {/* Pricing card */}
          <div className="p-8 md:p-12 rounded-2xl border border-border bg-card shadow-card">
            <div className="mb-8">
              <span className="text-4xl md:text-5xl font-display font-bold text-gradient-gold">
                Custom
              </span>
              <p className="text-muted-foreground mt-2">Pricing by request</p>
            </div>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-4 mb-10 text-left max-w-md mx-auto">
              {[
                "Monthly retainer structure",
                "Success fee alignment",
                "Flexible scope",
                "No hidden costs",
              ].map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0" />
                  <span className="text-sm text-muted-foreground">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <ContactFormDialog />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
